import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserDto } from '../../types/user.dto';

export type UserManageForm = FormGroup<{
  first_name: FormControl<string>;
  last_name: FormControl<string>;
  email: FormControl<string>;
  tel_no: FormControl<string>;
  role: FormControl<string | null>;
  status: FormControl<string | null>;
}>;

export function buildUserManageForm(user?: UserDto): UserManageForm {
  return new FormGroup({
    first_name: new FormControl(user?.first_name ?? '', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(100)],
    }),
    last_name: new FormControl(user?.last_name ?? '', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(100)],
    }),
    email: new FormControl(user?.email ?? '', {
      nonNullable: true,
      validators: [
        Validators.required,
        Validators.email,
        Validators.maxLength(200),
      ],
    }),
    tel_no: new FormControl(user?.tel_no ?? '', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(20)],
    }),
    role: new FormControl(user?.role ?? 'User', {
      validators: [Validators.required],
    }),
    status: new FormControl((user?.status ?? 'active').toLowerCase(), {
      validators: [Validators.required],
    }),
  });
}
